import { useState } from 'react';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';

interface SharedSessionAccessGateProps {
  title: string;
  description: string;
  loading?: boolean;
  error?: string | null;
  onSubmit: (password: string) => Promise<void> | void;
}

export function SharedSessionAccessGate({
  title,
  description,
  loading = false,
  error,
  onSubmit,
}: SharedSessionAccessGateProps) {
  const [password, setPassword] = useState('');

  return (
    <div className="min-h-screen bg-background flex items-center justify-center p-6">
      <div className="w-full max-w-md rounded-xl border bg-card p-6 shadow-sm space-y-4">
        <div className="space-y-1">
          <h1 className="text-xl font-semibold font-heading">{title}</h1>
          <p className="text-sm text-muted-foreground">{description}</p>
        </div>

        <form
          className="space-y-3"
          onSubmit={async (event) => {
            event.preventDefault();
            if (!password.trim() || loading) return;
            await onSubmit(password);
          }}
        >
          <Input
            type="password"
            value={password}
            onChange={(event) => setPassword(event.target.value)}
            placeholder="Enter session password"
            autoFocus
          />
          {error ? <p className="text-sm text-destructive">{error}</p> : null}
          <Button type="submit" className="w-full" disabled={loading || !password.trim()}>
            {loading ? 'Checking...' : 'Enter session'}
          </Button>
        </form>
      </div>
    </div>
  );
}
